import {
  Box,
  Button,
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { PublishState, SearchInput } from '../../../components';
import { Plus } from '@phosphor-icons/react';
import { Link, useParams } from 'react-router';
import { Api } from '../../../api';
import { useModifiableParams } from '../../../hooks';

export default function DailyTipsTab() {
  const { weekNumber, weekId } = useParams();

  const { getParams, setModifiedParams } = useModifiableParams();

  const params = getParams();

  const api = Api.DailyTip.useReadCollectionDailyTips(weekId ?? '', params);

  const tips = api.data?.member;

  return (
    <>
      <Stack direction="row" alignItems="end" spacing={2}>
        <SearchInput
          label="Search"
          value={params.title ?? ''}
          onChange={(e) => setModifiedParams({ title: e.target.value })}
          placeholder="Search by title"
        />
        <Box minWidth={185}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Plus />}
            component={Link}
            to={`/program/${weekNumber}/${weekId}/daily-tips/new`}
          >
            Create Daily Tip
          </Button>
        </Box>
      </Stack>
      <Card sx={{ mt: 2 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Day</TableCell>
                <TableCell>Publish State</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tips?.map((tip) => (
                <TableRow
                  component={Link}
                  to={`/program/${weekNumber}/${weekId}/daily-tips/${tip.id}`}
                  key={tip.id}
                  sx={{
                    cursor: 'pointer',
                    textDecoration: 'none',
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <TableCell>{tip.title}</TableCell>
                  <TableCell>{tip.day}</TableCell>
                  <TableCell>
                    <PublishState
                      item={{
                        publishAt: tip.publishedAt,
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </>
  );
}
